"use client";

/**
 * NewForm DS hover icon — a panel with a left rail, for showing/hiding a
 * sidebar. On hover the rail slides in toward the edge and back, previewing
 * the collapse the button performs.
 *
 * The rail is deliberately not wrapped in `.g`: a vertical line has a
 * zero-width bounding box, so `transform-box: fill-box` would give it a
 * degenerate origin. It only translates, which needs no origin at all.
 *
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function SidebarToggleIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <rect x="2.8" y="3.6" width="18.4" height="16.8" rx="2.6" />
      <path className="a-rail" d="M9.4 3.6v16.8" />
    </HoverIconSvg>
  );
}
